<template>
  <div>
    <div class="input-group color-picker" ref="colorpicker">
      <input type="text" class="form-control color-input" :value="color" @focus="showPicker()" @input="updateFromInput" />
      <span class="input-group-addon color-picker-container">
        <span class="current-color" :style="'background-color: ' + color" @click="togglePicker()"></span>
      </span>
  </div>
   <chrome-picker :value="color" @input="updateFromPicker" v-if="displayPicker" :disableFields=true :disableAlpha="disableAlpha" />
</div>
</template>

<script>

import {Chrome} from 'vue-color'

export default {
  name: 'color-picker',
  components: {
    'chrome-picker': Chrome
  },
  props: {
    color: '',
    creativeType: ''
  },
  data () {
    return {
      colorValue: '',
      type: 'psd',
      displayPicker: false,
      disableAlpha: true
    }
  },
  mounted () {
    this.setColor(this.color || '#000000')
    this.type = this.creativeType
    if (this.type === 'html') {
      this.disableAlpha = false
    }
  },
  methods: {
    setColor (color) {
      this.colorValue = color
    },
    showPicker () {
      document.addEventListener('click', this.documentClick)
      this.displayPicker = true
    },
    hidePicker () {
      document.removeEventListener('click', this.documentClick)
      this.displayPicker = false
    },
    togglePicker () {
      this.displayPicker ? this.hidePicker() : this.showPicker()
    },
    updateFromInput (color) {
      this.colorValue = color.target.value
      this.$emit('input', this.colorValue)
    },
    updateFromPicker (color) {
      if (color.rgba.a === 1 || this.type === 'psd') {
        this.colorValue = color.hex
      } else {
        this.colorValue = 'rgba(' + color.rgba.r + ', ' + color.rgba.g + ', ' + color.rgba.b + ', ' + color.rgba.a + ')'
      }
    }
  },
  watch: {
    colorValue (val) {
      if (val) {
        this.$emit('input', val)
      }
    }
  }
}

</script>

<style lang="scss">
  .vc-chrome {
    top: 35px;
    right: 0;
    z-index: 9;
    width:400px!important;
    max-width:100%;
  }
  .current-color {
    display: inline-block;
    width: 16px;
    height: 16px;
    background-color: #000;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/ColorPicker/color-picker.vue